module.exports = __webpack_public_path__ + "img/index-bg.272b1fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/cs180824/img/index-bg.jpg
// module id = tewZ
// module chunks = 3